import * as React from 'react'
function SvgEditInline(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20.2 11l8.8 8.8-15.6 15.6c-.4.4-.8.6-1.4.6H6c-1.2 0-2-.8-2-2v-6c0-.6.2-1 .6-1.4L20.2 11zm6.4-6.4c.8-.8 2-.8 2.8 0l6 6c.8.8.8 2 0 2.8L31.8 17 23 8.2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgEditInline
